import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z"
}), 'Upload');